// libraries
import { useEffect, useState } from 'react';
import { useParams, useHistory, useLocation } from 'react-router';
import styled from 'styled-components';

import { Tabs, notification } from 'antd';
import { CameraOutlined, UserOutlined, ProfileOutlined, CommentOutlined, MailOutlined } from '@ant-design/icons';

// components
import { UserPageHeader } from './user-page-header';
import { UserFormTab } from './tabs/user-form-tab';
import { UserPostsTab } from './tabs/posts-tab';
import { UserConversationsTab } from './tabs/conversations-tab';
import { UserImageTab } from './tabs/image-tab';
import { Spinner } from '../../../shared/spinner';

// services
import * as UserService from '../../../../services/bb-api/user';
import { txt } from '../../../../locales/i18n';
import { HeyLoyaltyTab } from './tabs/hey-loyalty-tab';

export function UserPage() {
	const [user, setUser] = useState<Record<string, any>>();
	const [loading, setLoading] = useState<boolean>(true);
	const [activeTab, setActiveTab] = useState<string>('');

	const { id } = useParams<any>();
	const history = useHistory();
	const location = useLocation();

	useEffect(() => setActiveTab(location.hash), [location.hash]);

	useEffect(() => {
		async function getUser(): Promise<void> {
			setLoading(true);

			try {
				const user: Record<string, any> = await UserService.get(id);
				setUser(user);
			} catch (error) {
				const message: string = (error as Error).name;
				const description: string = (error as Error).message;
				notification.error({ message, description });
				history.replace('/users');
			}
			setLoading(false);
		}

		getUser();
	}, [history, id]);

	if (loading || user === undefined) return <Spinner text="Getting data..." />;

	return (
		<StyledMain>
			<UserPageHeader user={user} />
			<Tabs activeKey={activeTab} onChange={(hash) => history.replace({ hash })} className="tab-container">
				<Tabs.TabPane
					key=""
					tab={[<UserOutlined key={1} />, txt('global.user')]}
					children={<UserFormTab useUser={[user, setUser]} />}
				/>

				<Tabs.TabPane
					key="#image"
					tab={[<CameraOutlined key={1} />, txt('global.image')]}
					children={<UserImageTab useUser={[user, setUser]} />}
				/>

				<Tabs.TabPane
					key="#posts"
					tab={[<ProfileOutlined key={1} />, txt('global.posts')]}
					children={<UserPostsTab />}
				/>

				<Tabs.TabPane
					key="#conversations"
					tab={[<CommentOutlined key={1} />, txt('global.conversations')]}
					children={<UserConversationsTab />}
				/>

				<Tabs.TabPane
					key="#heyloyalty"
					tab={[<MailOutlined key={1} />, 'Heyloyalty']}
					children={<HeyLoyaltyTab user={user} />}
				/>
			</Tabs>
		</StyledMain>
	);
}

const StyledMain = styled.main`
	height: 100%;
	display: flex;
	flex-direction: column;

	.tab-container {
		overflow-y: auto;
		padding: 0 2rem;
	}
`;
